// ═══════════════════════════════════════════════════════════
// «Джерела» клієнтів закладу (звідки клієнти; 23.10) — один запит на
// вкладку, спільний для картки клієнта, списку й налаштувань. Скидається,
// коли список зберігають у «Категоріях».
// Сервер — api/customers/sources.js.
// ═══════════════════════════════════════════════════════════
import { useState, useEffect } from 'react';
import { apiFetch } from './api';

export const NO_ORIGIN = '__none__';

let cache = null;   // Promise<{ sources, custom }>

export function invalidateCustomerSources() { cache = null; }

export function getCustomerSources() {
  if (!cache) {
    cache = apiFetch('/api/customers/sources')
      .then(r => ({ sources: r.sources || [], custom: !!r.custom }))
      .catch(() => { cache = null; return { sources: [], custom: false }; });
  }
  return cache;
}

export function useCustomerSources() {
  const [sources, setSources] = useState([]);
  useEffect(() => {
    let cancelled = false;
    getCustomerSources().then(r => { if (!cancelled) setSources(r.sources); });
    return () => { cancelled = true; };
  }, []);
  return sources;
}
